/**
 * Profile questionnaire options shared by the waiting-list wizard and the
 * onboarding wizard, verbatim from Figma (MVP-DESIGNES 9141:2939 .. 9220:3850
 * and 9226:4449 / 9358:1189).
 *
 * The labels double as the stored values: the backend validates each answer
 * against the exact same strings
 * (`optuneutils.parameter_validators.platform_access_params.WAITLIST_*_OPTIONS`,
 * reused by `users_params` for the onboarding answers), so keep both sides in
 * sync when a label changes.
 */

export const ROLE_OPTIONS = Object.freeze([
    'Developer',
    'AI Researcher',
    'DevOPS',
    'VP R&D',
    'Operations',
    'Founder or Leadership',
    'Quality Assurance',
    'Other',
]);

export const INDUSTRY_OPTIONS = Object.freeze([
    'Cyber Security',
    'Healthcare & Life Sciences',
    'Fintech & Banking',
    'Legal & Compliance',
    'Automotive & Autonomous Systems',
    'Telecommunications',
    'Energy & Utilities',
    'Other',
]);

export const COMPANY_SIZE_OPTIONS = Object.freeze(['Just me', '2-9', '10-49', '50-249', '250-999', '1,000+']);

/** "How did you hear about us?" — onboarding reading order (Figma 9226:4449, row by row). */
export const HEARD_ABOUT_OPTIONS = Object.freeze([
    'Friend or colleague',
    'Google or other search',
    'AI tool (LLM)',
    'Instagram or Facebook',
    'Twitter/X',
    'Newsletter or blog post',
    'Podcast',
    'LinkedIn',
    'Youtube',
    'Other',
]);
